var _defs, _polygon, _polygon2, _polygon3, _polygon4, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon5, _polygon6, _g4, _g5, _polygon7, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituation3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "situation_3",
    "data-name": "situation 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000 3307.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-50{fill:none;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_290);}.cls-3{fill:#cdd1d1;}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_292);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_292-2);}.cls-6{clip-path:url(#clip-path);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_292-3);}.cls-8{fill:#a8a8a8;}.cls-9{clip-path:url(#clip-path-2);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_292-4);}.cls-11{clip-path:url(#clip-path-3);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_292-5);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_292-6);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_292-7);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_292-8);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_292-9);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_292-10);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_292-11);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_292-12);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_292-13);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_292-14);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_292-15);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_292-16);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_292-17);}.cls-25{clip-path:url(#clip-path-4);}.cls-26{fill:#c8b9a7;}.cls-27{fill:#897866;}.cls-28{clip-path:url(#clip-path-5);}.cls-29,.cls-50{stroke:#000;stroke-miterlimit:10;stroke-width:2px;}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_181);}.cls-30{fill:#f2f2f2;}.cls-31{fill:#6f767a;}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_272);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_268);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_192);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_262);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_248);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_192-2);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_253);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_288);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_283);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_272-2);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_279);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_272-3);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_279-2);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_272-4);}.cls-46{fill:#444;}.cls-47{fill:#777;}.cls-48{fill:#6a6e6e;}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_197);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_190);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_190-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_290",
    x1: 2022.42,
    y1: 99.79,
    x2: 1282.63,
    y2: 3580.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292",
    x1: 878.39,
    y1: 1027.27,
    x2: 856.39,
    y2: 1000.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#cdd1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#afb3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7d8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-2",
    x1: 1535.39,
    y1: 341.27,
    x2: 1524.44,
    y2: 326.2,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 307.58)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,225c0-26-78-10-78,32L339,1292c0,32,81,42,78-62Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-3",
    x1: 228.19,
    y1: 772.61,
    x2: 315.82,
    y2: 753.99,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 307.58)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M806,0,979.61,801c0,24.75,64.81,32.49,62.41-48L873.82,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-4",
    x1: 890.82,
    y1: 399.54,
    x2: 963.59,
    y2: 384.08,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 307.58)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1421.56,0l68.09,314c0,18.2,47.65,23.88,45.88-35.26L1473.28,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-5",
    x1: 1424.37,
    y1: 18.81,
    x2: 1477.87,
    y2: 7.44,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-6",
    x1: 175.98,
    y1: 1288.5,
    x2: 153.97,
    y2: 1261.32,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-7",
    x1: 144.14,
    y1: 999.6,
    x2: 122.66,
    y2: 973.07,
    gradientTransform: "matrix(1, 0.07, -0.07, 1, 77.41, -5.04)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-8",
    x1: 124.11,
    y1: 734.83,
    x2: 102.48,
    y2: 703.29,
    gradientTransform: "translate(42.41 -1.36) rotate(3.44)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-9",
    x1: 75.99,
    y1: 450,
    x2: 57.4,
    y2: 419.46,
    gradientTransform: "translate(57.93 0.57) rotate(5.33)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-10",
    x1: 634.4,
    y1: 663.78,
    x2: 615.82,
    y2: 637.25,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-11",
    x1: 681.46,
    y1: 876.06,
    x2: 662.42,
    y2: 852.54,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-12",
    x1: 593.98,
    y1: 466.69,
    x2: 577.84,
    y2: 438.74,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-13",
    x1: 543.94,
    y1: 238.42,
    x2: 528.75,
    y2: 207.27,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-14",
    x1: 1250.52,
    y1: 410.35,
    x2: 1236.2,
    y2: 392.67,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-15",
    x1: 1215.02,
    y1: 257.82,
    x2: 1201.68,
    y2: 238.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-16",
    x1: 1160.65,
    y1: 441.04,
    x2: 1148.54,
    y2: 420.05,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_292-17",
    x1: 964.27,
    y1: 343.66,
    x2: 953.28,
    y2: 321.11,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_292"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 307.58)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "592 1566.63 653.65 1751.58 2414.69 2332 2596 1510 932.81 1151.38 592 1566.63"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 307.58)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1035.17 1628.28 853.71 890.83 1423.67 383.69 2758.99 554.67 2567.07 1216.52 2344.9 2012.13 1035.17 1628.28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_181",
    x1: 1806.35,
    y1: 691.26,
    x2: 1806.35,
    y2: 2319.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdd1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#b6baba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9b9f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#8c9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868a8a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_272",
    x1: 1770.29,
    y1: 1355.44,
    x2: 1770.29,
    y2: 2182.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7d8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_268",
    x1: 1682.07,
    y1: 1072.15,
    x2: 1558.21,
    y2: 1654.83,
    gradientTransform: "translate(87.75 189.65) rotate(4.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7f8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#949999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#a3a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#acb0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb3b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_192",
    x1: 1522.01,
    y1: 1547.62,
    x2: 1506.91,
    y2: 1633.21,
    gradientTransform: "translate(87.75 189.65) rotate(4.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_262",
    x1: 1713.55,
    y1: 1081.43,
    x2: 1611.99,
    y2: 1657.43,
    gradientTransform: "translate(87.75 189.65) rotate(4.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#9da1a1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_248",
    x1: 2156.11,
    y1: 1481.08,
    x2: 2029.47,
    y2: 2076.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8e9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a3a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#b2b7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#bbbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec2c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_192-2",
    x1: 1992.4,
    y1: 1969.52,
    x2: 1977.31,
    y2: 2055.11,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_192"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_253",
    x1: 2187.43,
    y1: 1489.95,
    x2: 2083.47,
    y2: 2079.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#989c9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_288",
    x1: 1861.46,
    y1: 1113.45,
    x2: 1795.56,
    y2: 1487.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9b0b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4d9d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_283",
    x1: 1321.31,
    y1: 1444.5,
    x2: 1321.31,
    y2: 1499.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#999c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#7d8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_272-2",
    x1: 1321.31,
    y1: 1733.47,
    x2: 1321.31,
    y2: 1788.14,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_272"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_279",
    x1: 1369,
    y1: 1275.26,
    x2: 1449.26,
    y2: 1275.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#999c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7d8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_272-3",
    x1: 1409.13,
    y1: 1467.1,
    x2: 1409.13,
    y2: 1512.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_272"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_279-2",
    x1: 1281.76,
    y1: 1378.78,
    x2: 1362.02,
    y2: 1378.78,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_279"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_272-4",
    x1: 1321.89,
    y1: 1570.62,
    x2: 1321.89,
    y2: 1615.99,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_272"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_197",
    x1: 1859.86,
    y1: 1907.44,
    x2: 1859.86,
    y2: 1907.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7f8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cdd1d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_190",
    x1: 2918.47,
    y1: 1059.43,
    x2: 2811.35,
    y2: 1563.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6a6e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdd1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#afb3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#7d8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_190-2",
    x1: 2704.7,
    y1: 934.6,
    x2: 2565.72,
    y2: 1588.46,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_190"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Situation 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 1807.58 1789 307.58 3000 307.58 3000 3307.58 0 3307.58 0 1807.58"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1789 307.58 0 307.58 0 1807.58 1789 307.58"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 1738.58 1750 307.58 1728 307.58 0 1693.58 0 1738.58"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1488 373.58 1581.77 307.58 1554.68 307.58 1484 355.58 1488 373.58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200,225c0-26-78-10-78,32L339,1292c0,32,81,42,78-62Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M122,257s22,22,55-5,21-40,21-40l-69-13-13,28",
    transform: "translate(0 307.58)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M868.4-24.26C868.4-44.37,806-32,806,.49L979.61,801c0,24.75,64.81,32.49,62.41-48Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M806,0s15.54,15.51,39.32,0H806",
    transform: "translate(0 307.58)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1407.88-292.79c0-14.79-45.88-5.69-45.88,18.19L1489.65,314c0,18.2,47.65,23.88,45.88-35.26Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1362-274.6s12.94,12.51,32.35-2.84,12.36-22.75,12.36-22.75l-40.59-7.39-7.65,15.92",
    transform: "translate(0 307.58)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M0,1431l330.35-270.13C354,1142,335,1117,325,1125.31L0,1386Z",
    transform: "translate(0 307.58)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M0,1105.63,274.4,912.79c25-17.1,7.84-43.42-2.72-35.86L0,1064.06Z",
    transform: "translate(0 307.58)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M0,809.66l222-130c24.74-17.42,7.27-43.51-3.19-35.82L0,768.43Z",
    transform: "translate(0 307.58)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M0,500.14l162.48-78.95c25.3-16.59,8.71-43.24-2-35.9L0,460.67Z",
    transform: "translate(0 307.58)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M339.31,869,914,468c15-12,5-34-4.91-26.26L332.15,835.88Z",
    transform: "translate(0 307.58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M391.31,1111,954,650c15-12,5-34-4.91-26.26L384.15,1077.88Z",
    transform: "translate(0 307.58)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M290.31,642,880,294c15-12,5-34-4.91-26.26L283.15,608.88Z",
    transform: "translate(0 307.58)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M235.31,387,838,95c15-12,5-34-4.91-26.26L228.15,353.88Z",
    transform: "translate(0 307.58)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1009.14,605.81l470.07-384.38C1491,210,1482,197,1474.54,203.3L1003.6,581Z",
    transform: "translate(0 307.58)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M969.14,426.81,1448.21,93.43C1460,82,1451,69,1443.54,75.3L963.6,402Z",
    transform: "translate(0 307.58)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "933.14 572.39 1386.95 307.58 1349.51 307.58 927.6 547.61 933.14 572.39"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "890.14 379.39 1038.24 307.58 984.46 307.58 884.6 354.61 890.14 379.39"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "592 1874.21 653.65 2059.16 2414.69 2639.58 2643.84 1827.68 932.81 1458.96 592 1874.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "592 1874.21 2453 2467.58 2601.96 1798.61 2883.45 1798.61 2711.3 2139.41 2401.9 2708.2 572.23 2088.24 592 1874.21"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "1035.17 1935.86 853.71 1198.41 1423.67 691.26 2758.99 862.25 2567.07 1524.1 2344.9 2319.71 1035.17 1935.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "853.71 1198.41 2567.07 1524.1 2758.99 862.25 1423.67 691.26 853.71 1198.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1087.51 1792.79 1491.13 1355.44 968.87 1257.73 1087.51 1792.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "2453.08 1540.38 2299.54 2182.45 1101.47 1857.93 1087.51 1792.79 1491.13 1355.44 2453.08 1540.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1440.83 1929.47 1448.08 1829.7 1521.33 1705.56 1705.16 1394.98 1788.9 1410.11 1521.28 1945.81 1440.83 1929.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "1449.54 1921.94 1455.77 1836.1 1520.07 1850.09 1510.44 1934.53 1449.54 1921.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1521.28 1945.81 1528.27 1849.52 1754.01 1404.29 1788.9 1410.11 1521.28 1945.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "1945.93 2059.16 1945.93 1959.12 2010 1830 2179.73 1488.04 2259.99 1503.16 2027.36 2069.62 1945.93 2059.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "1954.08 2051.01 1954.08 1964.94 2019.21 1974.24 2015.72 2059.16 1954.08 2051.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "2027.36 2069.62 2027.36 1973.08 2222.77 1496.18 2259.99 1503.16 2027.36 2069.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1535.33,1417.75l532.74,117.48,10.46-97.71s76.77-43,96.55-139.58-1.17-118.64-1.17-118.64l-648.36-125.08s-35.58,192.54,67.94,262.33l-58.16,51.18Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1363.26,1453.8c-10.24-5.7-25.23-9.3-42-9.3s-31.72,3.6-42,9.3h-13.88v19.78h.12c1.84,14.28,26.07,25.59,55.71,25.59s53.87-11.31,55.71-25.59h.12V1453.8Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-41",
    cx: 1321.31,
    cy: 1760.8,
    rx: 55.83,
    ry: 27.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1449.26,1182.79H1369v161.68h0c0,.19,0,.38,0,.58,0,12.53,18,22.68,40.13,22.68s40.13-10.15,40.13-22.68c0-.2,0-.39,0-.58h0Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 1409.13,
    cy: 1489.78,
    rx: 40.13,
    ry: 22.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1362,1286.31h-80.26V1448h0c0,.19,0,.39,0,.58,0,12.53,18,22.68,40.13,22.68s40.13-10.15,40.13-22.68c0-.19,0-.39,0-.58h0Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-45",
    cx: 1321.89,
    cy: 1593.3,
    rx: 40.13,
    ry: 22.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1293,1119.46s-8.9-62.65,50.79-77.87,81.65,45.15,81.65,45.15,15.71,38.88-15.62,65.19S1293,1119.46,1293,1119.46Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1283.43,1129.12s-8.9-62.66,50.78-77.87,81.65,45.15,81.65,45.15,15.71,38.88-15.62,65.18S1283.43,1129.12,1283.43,1129.12Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1406.52,1197.2c-20.08,28.66-66.84,30.53-104.45,4.18s-51.81-71-31.73-99.61c13.18-18.8,37.85-26.07,63.88-21.4a102.94,102.94,0,0,1,40.57,17.23C1412.4,1124,1426.6,1168.54,1406.52,1197.2Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1338.76,1079.26c10.47,0,489,45.34,489,45.34s14.2-3.73,39.44.48,45.34,16.59,45.34,16.59-17.78-14.72-34.06-18.21-553.67-51.18-553.67-51.18-27,.26-42.61,17.58C1292.23,1081.59,1313.17,1075.77,1338.76,1079.26Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1376.6,1217.54l437.59,110.91a114.56,114.56,0,0,1-33.32-25.14c-23.37-5.37-379.9-99.52-379.9-99.52S1388.77,1215.35,1376.6,1217.54Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1860.35,1124.13c-41.2-3-91.22,28.41-105.18,77.27-16.68,58.37,30.78,131.11,96.55,138.41s108.88-32.87,115.58-93.21S1934.75,1129.55,1860.35,1124.13Zm-3.56,32.07a75.05,75.05,0,0,1,11.12.89c-3.51,7.08-8.76,17.91-16.19,33.84-34.9-1.17-45.37,17.45-45.37,17.45l-30.74,0C1786.48,1174.57,1821.43,1156.05,1856.79,1156.2Zm-9.73,154.53c-39.12-4.34-67.82-33-73.75-67l27.23,1.88s-3.24,11.55,14,32.57c10.47,12.79,53.51,9.3,53.51,9.3l12.67,20.59A85.28,85.28,0,0,1,1847.06,1310.73Zm86.5-67.87c-1.87,16.89-8.46,31.86-18.65,43.47-3.81-4.47-11.2-13.71-22.48-30.26,10.47-37.23-11.64-52.35-11.64-52.35l17.42-34.82C1922.37,1185,1936.74,1214.2,1933.56,1242.86Z",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1859.86,1907.44",
    transform: "translate(0 307.58)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "968.87 1257.73 899.08 1244.93 1060.76 1899.8 1101.47 1857.93 968.87 1257.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1060.76 1899.8 1101.47 1857.93 2299.54 2182.45 2280.93 2247.59 1060.76 1899.8"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "1035.17 1935.86 853.71 1198.41 1423.67 691.26 2758.99 862.25 2567.07 1524.1 2344.9 2319.71 1035.17 1935.86"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M3000,1076.76l-220.07-39.37c-29.9,174.21-87.77,334.24-155.87,486.21L3000,1596.76Z",
    transform: "translate(0 307.58)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M2652,923.4l125.62,26.75v87.24c23.63,0-123.84,474.56-155.86,486.21-9.31,19.77-47.69,65.13-47.69,65.13l-105.17-20.85Z",
    transform: "translate(0 307.58)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituation3);
export default __webpack_public_path__ + "static/media/situation_3.8584c730f1bc9bd44c3eae4981638295.svg";
export { ForwardRef as ReactComponent };